import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  therapyData: {},
  mhc: {},
};

const bulkSearchSlice = createSlice({
  name: 'bulkSearch',
  initialState,
  reducers: {
    setBulkSearchMHCData: (state, action) => {
      state.mhc = {
        ...state.mhc,
        ...action.payload,
      };
    },
    setBulkSearchTherapyData: (state, action) => {
      state.therapyData = {
        ...state.therapyData,
        ...action.payload,
      };
    },
    clearBulkSearchMHCData: (state) => {
      state.mhc = {};
    },
    clearBulkSearchTherapyData: (state) => {
      state.therapyData = {};
    },
    deleteBulkSearchMHCData: (state, action) => {
      delete state.mhc[action.payload];
    },

    deleteBulkSearchTherapyData: (state, action) => {
      delete state.therapyData[action.payload];
    },
  },
});

export const {
  setBulkSearchMHCData,
  setBulkSearchTherapyData,
  clearBulkSearchMHCData,
  clearBulkSearchTherapyData,
  deleteBulkSearchMHCData,
  deleteBulkSearchTherapyData,
} = bulkSearchSlice.actions;
export default bulkSearchSlice.reducer;
